package services.storage.http

import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import serialized.SearchForProjectsResult

/**
 * Response for
 */
@Serializable
sealed interface FetchSearchForProjectsResponse : RestResponse<SearchForProjectsResult> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: SearchForProjectsResult) : FetchSearchForProjectsResponse, RestResponse.GoodResponse<SearchForProjectsResult>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchSearchForProjectsResponse, RestResponse.BadResponse<SearchForProjectsResult>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: SearchForProjectsResult): FetchSearchForProjectsResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): FetchSearchForProjectsResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: SearchForProjectsResult?): FetchSearchForProjectsResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }
  }
}
